module.exports = __webpack_public_path__ + "img/loader.a9f6d14f.gif";